import React from "react";
import { connect } from "react-redux";
import "./PopUpModal.scss";
import { CloseModal } from "./popUpContainerSlice";

function PopUpModal({ Component, isOpen, CloseModal }) {

  if (!isOpen) return null;

  return (
    <div className="modal-backdrop">
      <div className="modal-container">
        <button className="modal-close-btn" onClick={() => CloseModal()}>
          X
        </button>
        {Component}
      </div>
    </div>
  );
} 

const mapStateToProps = (state) => ({
  Component: state.popUpContainerBlock.Component,
  isOpen: state.popUpContainerBlock.isOpen,
});

const mapDispatchToProps = {    
    CloseModal    
}
export default connect(mapStateToProps, mapDispatchToProps)(PopUpModal);
